var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('list-layout',{attrs:{"hasHeader":false,"isReadonly":_vm.isEvaluated.isReadOnly},scopedSlots:_vm._u([{key:"content",fn:function(){return [_c('referral-doctors-table')]},proxy:true}])})}
var staticRenderFns = []

export { render, staticRenderFns }